export default __webpack_public_path__ + "pgnv-assets/1c0d5c37b2d358bf9c569f9f281ddb75.png";